import { BoardsPage } from '@/features/boards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/boards/')({
  component: BoardsPage,
});
